/**
 * Campaign create/update Zod schemas
 */

import { z } from 'zod'
import { ALL_STRATEGIES } from '../constants/strategies'
import { CAMPAIGN_STATUSES } from '../constants/statuses'

const strategyEnum = z.enum(ALL_STRATEGIES as unknown as [string, ...string[]])

export const createCampaignSchema = z.object({
  name: z.string().min(1).max(200),
  strategy: strategyEnum,
  targetPersona: z.string().max(500).optional(),
  targetIndustry: z.string().max(200).optional(),
  offerDescription: z.string().max(2000).optional(),
  followUpSteps: z.number().int().min(1).max(7).optional(),
  dailyConnectionLimit: z.number().int().min(1).max(100).optional(),
  dailyMessageLimit: z.number().int().min(1).max(150).optional(),
  activityWindowStart: z.number().int().min(0).max(23).default(8),
  activityWindowEnd: z.number().int().min(0).max(23).default(20),
  timezone: z.string().default('America/New_York'),
  weekdaysOnly: z.boolean().default(true),
})

export const updateCampaignSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  strategy: strategyEnum.optional(),
  status: z.enum(CAMPAIGN_STATUSES as unknown as [string, ...string[]]).optional(),
  targetPersona: z.string().max(500).optional(),
  targetIndustry: z.string().max(200).optional(),
  offerDescription: z.string().max(2000).optional(),
  followUpSteps: z.number().int().min(1).max(7).optional(),
  dailyConnectionLimit: z.number().int().min(1).max(100).optional(),
  dailyMessageLimit: z.number().int().min(1).max(150).optional(),
  activityWindowStart: z.number().int().min(0).max(23).optional(),
  activityWindowEnd: z.number().int().min(0).max(23).optional(),
  timezone: z.string().optional(),
  weekdaysOnly: z.boolean().optional(),
})

export type CreateCampaignInput = z.infer<typeof createCampaignSchema>
export type UpdateCampaignInput = z.infer<typeof updateCampaignSchema>
